export default __webpack_public_path__ + "static/media/national-indigenous-history-month-2022.b51afe0a.jpeg";